class ProductDemo extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.addEventListener('click', this.onDemoClick.bind(this));
    this.addEventListener('keydown', this.onTabKeydown.bind(this));
    this.updateTotals();
  }

  onDemoClick(event) {
    const quantityButton = event.target.closest('[data-quantity]');
    if (quantityButton) {
      this.changeVariantQuantity(quantityButton);
      return;
    }

    const tab = event.target.closest('[data-tab]');
    if (tab) {
      this.activateTab(tab);
      return;
    }

    const togetherQuantity = event.target.closest('[data-together-quantity]');
    if (togetherQuantity) {
      this.changeTogetherQuantity(togetherQuantity);
      return;
    }

    const wishlist = event.target.closest('[data-wishlist]');
    if (wishlist) {
      this.toggleWishlist(wishlist);
      return;
    }

    if (event.target.closest('[data-demo-action]')) {
      const notice = this.querySelector('[data-demo-notice]');
      notice.hidden = false;
    }
  }

  changeVariantQuantity(quantityButton) {
    const input = quantityButton.closest('[data-variant]').querySelector('input');
    const direction = quantityButton.dataset.quantity === 'increase' ? 1 : -1;
    input.value = Math.max(0, Number(input.value) + direction);
    this.updateTotals();
  }

  changeTogetherQuantity(quantityButton) {
    const output = this.querySelector('[data-together-output]');
    const direction = quantityButton.dataset.togetherQuantity === 'increase' ? 1 : -1;
    output.textContent = String(Math.max(1, Number(output.textContent) + direction));
  }

  toggleWishlist(wishlistButton) {
    const isActive = wishlistButton.getAttribute('aria-pressed') === 'true';
    wishlistButton.setAttribute('aria-pressed', String(!isActive));
    wishlistButton.setAttribute('aria-label', isActive ? 'إضافة إلى قائمة الرغبات' : 'إزالة من قائمة الرغبات');
  }

  onTabKeydown(event) {
    const tab = event.target.closest('[data-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...this.querySelectorAll('[data-tab]')];
    const currentIndex = tabs.indexOf(tab);
    let nextIndex = currentIndex;

    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;

    event.preventDefault();
    this.activateTab(tabs[nextIndex]);
    tabs[nextIndex].focus();
  }

  activateTab(activeTab) {
    this.querySelectorAll('[data-tab]').forEach((tab) => {
      const selected = tab === activeTab;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });

    this.querySelectorAll('[data-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.panel !== activeTab.dataset.tab;
    });
  }

  updateTotals() {
    const total = [...this.querySelectorAll('[data-variant] input')].reduce((sum, input) => sum + Number(input.value), 0);
    const selected = this.querySelector('[data-selected]');
    const addButton = this.querySelector('[data-add-text]').closest('button');
    const addText = this.querySelector('[data-add-text]');

    selected.textContent = total > 0 ? `${total} ${this.dataset.meterLabel}` : '';
    addButton.disabled = total === 0;
    addText.textContent = total === 0
      ? addText.dataset.empty
      : `${this.dataset.addLabel} — ${(total * Number(this.dataset.unitPrice)).toLocaleString('en-US')} ${this.dataset.currency}`;
  }
}

if (!customElements.get('product-demo')) {
  customElements.define('product-demo', ProductDemo);
}
